<template>
  <div class="mall-field-label">
    <span class="mall-field-label__text">{{ label }}</span>
    <img v-if="required" class="mall-field-label__essential" src="@/assets/mall/icn_star_essential.svg" alt="필수" />
  </div>
</template>

<script>
export default {
  name: 'MallFieldLabel',
  props: {
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.mall-field-label {
  display: flex;
  padding: 0 4px;
  align-items: flex-start;
  gap: 4px;
}

.mall-field-label__text {
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-field-label__essential {
  display: block;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallFieldLabel.vue